import type { ChromeCopy } from '../types/chrome';

export const chromeEn: ChromeCopy = {
  siteMeta: {
    defaultTitle: 'SafestMenu - QR code menus for restaurants | safestmenu.com',
    defaultDescription:
      'Create a digital, multilingual QR code menu with SafestMenu at safestmenu.com. Guests scan; you update prices instantly. Hygienic and free to start.',
  },
  header: {
    homeAriaLabel: 'SafestMenu home',
    mainNavAriaLabel: 'Main',
    mobileNavAriaLabel: 'Mobile',
    nav: {
      why: 'Why SafestMenu',
      howItWorks: 'How it works',
      aboutUs: 'About us',
    },
    ctaLabel: 'Open the app',
    openMenuAriaLabel: 'Open menu',
    closeMenuAriaLabel: 'Close menu',
  },
  footer: {
    tagline:
      'The QR code menu for restaurants, cafés and bars. Easy to set up, safe for your guests, kind to nature.',
    siteNavAriaLabel: 'Site',
    legalNavAriaLabel: 'Legal',
    exploreHeading: 'Explore',
    companyHeading: 'Company',
    nav: {
      why: 'Why SafestMenu',
      howItWorks: 'How it works',
      allergenGuide: 'EU allergen guide',
      blog: 'Blog',
      openApp: 'Open the app',
      aboutUs: 'About us',
      impressum: 'Impressum',
      terms: 'Terms & Conditions',
      transfactorDev: 'transfactor.dev',
    },
    craftedBy: 'Crafted by',
    copyrightSuffix: 'SafestMenu. All rights reserved.',
  },
  consent: {
    message:
      'We use cookies for analytics and to measure advertising performance. You can accept or decline - the site works the same either way. We do not use them for ad personalisation.',
    decline: 'Decline',
    accept: 'Accept',
    settings: 'Cookie settings',
  },
  languageSwitcher: {
    label: 'Change language',
  },
  localeSuggestion: {
    message: 'This page is also available in English.',
    accept: 'View in English',
    dismiss: 'No thanks',
  },
  emailCapture: {
    defaultTitle: 'Get menu tips in your inbox',
    defaultDescription:
      'Occasional, practical notes on menus, allergens and running a restaurant without paper. No spam.',
    defaultPlaceholder: 'you@restaurant.com',
    defaultButtonLabel: 'Subscribe',
    emailLabel: 'Email address',
    loadingButtonLabel: 'Subscribing…',
    successMessage: 'You’re on the list. Watch your inbox for menu tips.',
    errorMessage: 'Something went wrong. Please try again in a moment.',
  },
  qrPlate: {
    linkAriaLabel: 'Scan or tap to open the live SafestMenu demo menu',
    svgAriaLabelPrefix: 'QR code linking to ',
    caption: "Scan or click - it's real",
  },
  notFound: {
    seoTitle: 'Page not found',
    heading: 'This dish is not on the menu.',
    message: 'The page you are looking for does not exist or has moved.',
    backLabel: 'Back to the menu',
  },
  blog: {
    seoTitle: 'Blog',
    seoDescription:
      'Practical notes on QR menus, guest experience and running a restaurant without paper.',
    eyebrow: 'Blog',
    heading: 'Notes on menus, guests and running a restaurant without paper.',
    emptyMessage: 'New posts are on the way.',
  },
};
